<script setup lang="ts">
/**
 * `/offerings` ya no es una pantalla: el listado se partió en Services y
 * Rentals (§24).
 *
 * Queda como redirect y no se borra porque el nombre `dive-centers-id-offerings`
 * está referenciado en el Overview del centro, en los avisos de "Needs
 * attention" y en enlaces que la gente puede tener guardados.
 */
definePage({
  meta: { requiresAuth: true },
  redirect: to => ({
    name: 'dive-centers-id-offerings-services',
    params: { id: to.params.id },
  }),
})
</script>

<template>
  <div />
</template>
